module.exports = __webpack_public_path__ + "static/speed-9328d60d6f020a83c7efa96c2351aed7.jpg";